export const news = {
  newsPageTitle: "Promociones y Noticias",
  newsPageSubtitle: "Lo último en promociones, torneos y novedades",
  newsNew: "Nuevo",
  newsReadMore: "Leer más",
  newsLoadMore: "Mostrar más noticias",
  articleBadgePromo: "Promoción",
  articleNotFound: "Artículo no encontrado",
  articleBackToNews: "Volver a Noticias",
  articleCtaTitle: "¿Listo para jugar?",
  articleCtaSubtitle: "Descubre esta promoción y empieza a jugar",
  articleCtaPlay: "Jugar ahora",
  articleCtaMore: "Ver más promociones",
  articleRelated: "Más noticias",
  articleViewAll: "Ver todas",
};
